/** Feedback Submit Request */
export const FEEDBACK_SUBMIT_REQUEST = 'FEEDBACK_SUBMIT_REQUEST';
export const FEEDBACK_SUBMIT_SUCCESS = 'FEEDBACK_SUBMIT_SUCCESS';
export const FEEDBACK_SUBMIT_FAILED = 'FEEDBACK_SUBMIT_FAILED';
export const RESET_FAILURE_FLAG = 'RESET_FAILURE_FLAG';